export default {
  setSetup(state, setup) {
    state.setup = setup;
  },
  setActiveContent(state, productId) {
    const parsed = parseInt(productId, 10);
    state.activeContentProductId = Number.isNaN(parsed) ? null : parsed;
  },
  setLoading(state, loading) {
    state.loading = loading;
  }
};
